import { isSameDay, parse } from 'date-fns'

export const DAY_MINUTES = 24 * 60
export const MIN_WINDOW_SPAN_MINUTES = 60
export const MAX_WINDOW_SPAN_MINUTES = 8 * 60

export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(max, value))

export const parseTimeToMinutes = (value?: string): number | null => {
  if (!value) return null

  const timestampSeparatorIndex = value.indexOf('T')
  const time =
    timestampSeparatorIndex === -1
      ? value
      : value.slice(timestampSeparatorIndex + 1, timestampSeparatorIndex + 6)
  const parsed = parse(time, 'HH:mm', new Date())
  if (Number.isNaN(parsed.getTime())) return null
  return parsed.getHours() * 60 + parsed.getMinutes()
}

export const isOvernightTimeRange = (start: string, end: string): boolean => {
  const startMinutes = parseTimeToMinutes(start)
  const endMinutes = parseTimeToMinutes(end)
  return startMinutes != null && endMinutes != null && endMinutes < startMinutes
}

export const minutesToHHmm = (minutes: number): string => {
  const bounded = clamp(Math.round(minutes), 0, DAY_MINUTES - 1)
  const hour = Math.floor(bounded / 60)
  const minute = bounded % 60
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

export const pixelsToMinutes = (
  deltaX: number,
  contentWidth: number,
  windowSpan: number
): number => {
  if (contentWidth <= 0) return 0
  return (deltaX / contentWidth) * windowSpan
}

export const shouldShowNowLine = (
  timelineDate: Date,
  now: Date,
  windowStart: number,
  windowEnd: number
): boolean => {
  const nowMinutes = now.getHours() * 60 + now.getMinutes()
  return isSameDay(timelineDate, now) && nowMinutes >= windowStart && nowMinutes <= windowEnd
}

export const clampWindowStart = (candidateStart: number, currentEnd: number): number => {
  const minStart = Math.max(0, currentEnd - MAX_WINDOW_SPAN_MINUTES)
  const maxStart = Math.min(
    DAY_MINUTES - MIN_WINDOW_SPAN_MINUTES,
    currentEnd - MIN_WINDOW_SPAN_MINUTES
  )
  return clamp(candidateStart, minStart, maxStart)
}

export const clampWindowEnd = (candidateEnd: number, currentStart: number): number => {
  const minEnd = Math.max(MIN_WINDOW_SPAN_MINUTES, currentStart + MIN_WINDOW_SPAN_MINUTES)
  const maxEnd = Math.min(DAY_MINUTES, currentStart + MAX_WINDOW_SPAN_MINUTES)
  return clamp(candidateEnd, minEnd, maxEnd)
}
